import { Button } from '@medly-components/core';
import { useStorage } from '@medly-components/utils';
import { TourHeader } from 'components/common/GuidedTour/GuidedTour.styled';
import { NO_THANKS, START_THE_TOUR } from 'constants/text/common';
import { UserContext } from 'context/UserContext';
import { useCallback, useContext } from 'react';
import { DialogBoxFooter } from '../../../../pages/Map/components/MapTour/MapTourDialogBox.styled';
import { TourConfirmationWrapper } from './TourConfirmationDialog.styled';

export type TourConfirmationDialog = {
    onCancel: () => void;
    onContinue: () => void;
    tourStatusKey: string;
    confirmationText: string;
    resumeText: string;
    fadeOut?: boolean;
};
export const TourConfirmationDialog = ({
    onCancel,
    onContinue,
    tourStatusKey,
    confirmationText,
    resumeText,
    fadeOut
}: TourConfirmationDialog) => {
    const { getKeyWithUserId } = useContext(UserContext);
    const [isTourStarted, setIsTourStarted] = useStorage<boolean>(getKeyWithUserId(tourStatusKey), { initialValue: false });

    const handleContinueClick = useCallback(() => {
        setIsTourStarted(true);
        onContinue();
    }, []);

    const handleCancelClick = () => {
        onCancel();
    };

    return (
        <TourConfirmationWrapper data-testid="tour-confirmation-wrapper" fadeOut={fadeOut}>
            <TourHeader>{isTourStarted ? resumeText : confirmationText}</TourHeader>
            <DialogBoxFooter>
                <Button size="L" fullWidth onClick={handleContinueClick}>
                    {START_THE_TOUR}
                </Button>
                <Button size="L" fullWidth variant="outlined" onClick={handleCancelClick}>
                    {NO_THANKS}
                </Button>
            </DialogBoxFooter>
        </TourConfirmationWrapper>
    );
};
